var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","name":"remember-me","id":"remember-me"}}),_vm._v(" "),_c('label',{attrs:{"for":"remember-me"}},[_vm._v(_vm._s(_vm.$t('Remember me')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d374b69e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/component/inputs/checkbox/checkbox.html
// module id = null
// module chunks = 